<app-edit-favorite [favorite]="favorite"></app-edit-favorite>
